import { Info } from "lucide-react";
import type { WorkflowDetail, WorkflowStep } from "../types";

type Props = {
  detail: WorkflowDetail;
  onOpen: (step: WorkflowStep) => void;
};

/** The steps of a workflow in order. Each step opens its text. */
export const WorkflowSteps = ({ detail, onOpen }: Props) => (
  <ol aria-label={`Steps of ${detail.label}`} className="space-y-2">
    {detail.steps.map((step) => {
      const noteId = `workflow-step-${step.number}-note`;
      return (
        <li key={step.number}>
          <button
            type="button"
            aria-label={`Step ${step.number}: ${step.label}. Open its text.`}
            aria-describedby={step.note ? noteId : undefined}
            onClick={() => onOpen(step)}
            className="flex w-full items-start gap-3 rounded-lg border border-zinc-200 bg-white p-3 text-left shadow-sm transition-colors hover:border-zinc-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900"
          >
            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-zinc-900 text-xs font-semibold text-white">
              {step.number}
            </span>
            <span className="min-w-0 flex-1">
              <span className="block text-sm font-semibold leading-7 text-zinc-900">
                {step.label}
              </span>
              <span className="block break-words font-mono text-2xs text-zinc-500">
                {step.source}
              </span>
              {step.note && (
                <span
                  id={noteId}
                  className="mt-2 flex items-start gap-1.5 text-xs leading-5 text-zinc-700"
                >
                  <Info className="mt-0.5 h-3.5 w-3.5 shrink-0 text-zinc-500" aria-hidden />
                  {step.note}
                </span>
              )}
            </span>
          </button>
        </li>
      );
    })}
  </ol>
);
